import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><path style={{
    fill: "#4173CD"
  }} d="M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621  c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38  C512,406.557,494.833,423.724,473.655,423.724z" /><path style={{
    fill: "#F5F5F5"
  }} d="M256,384c-70.578,0-128-57.422-128-128s57.422-128,128-128s128,57.422,128,128S326.578,384,256,384z   M256,154.483c-55.979,0-101.517,45.539-101.517,101.517S200.022,357.517,256,357.517S357.517,311.978,357.517,256  S311.979,154.483,256,154.483z" /><g><path style={{
      fill: "#FFDC00"
    }} d="M256,375.172c-65.711,0-119.172-53.461-119.172-119.172S190.289,136.828,256,136.828   S375.172,190.289,375.172,256S321.711,375.172,256,375.172z M256,145.655c-60.845,0-110.345,49.5-110.345,110.345   S195.155,366.345,256,366.345S366.345,316.845,366.345,256S316.845,145.655,256,145.655z" /><circle style={{
      fill: "#FFDC00"
    }} cx={141.24} cy={256} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={370.76} cy={256} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={256} cy={141.24} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={174.85} cy={174.85} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={337.15} cy={174.85} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={362.02} cy={212.08} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={212.08} cy={149.98} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={149.98} cy={212.08} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={299.92} cy={149.98} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={368.55} cy={233.61} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={233.61} cy={143.45} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={160.59} cy={192.24} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={319.76} cy={160.59} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={351.42} cy={192.24} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={192.24} cy={160.59} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={143.45} cy={233.61} r={8.828} /><circle style={{
      fill: "#FFDC00"
    }} cx={278.39} cy={143.45} r={8.828} /></g><path style={{
    fill: "#FFA000"
  }} d="M370.759,260.414c-2.44,0-4.414-1.974-4.414-4.414c0-60.845-49.5-110.345-110.345-110.345  S145.655,195.155,145.655,256c0,2.44-1.974,4.414-4.414,4.414s-4.414-1.974-4.414-4.414c0-65.711,53.461-119.172,119.172-119.172  S375.172,190.289,375.172,256C375.172,258.44,373.198,260.414,370.759,260.414z" /><path style={{
    fill: "#B4B4B4"
  }} d="M280.526,388.414h-49.054c-10.482,0-18.656-9.079-17.558-19.503l15.603-148.221h52.966  l15.602,148.221C299.182,379.335,291.009,388.414,280.526,388.414z" /><path style={{
    fill: "#AAAAAA"
  }} d="M282.232,220.69h-52.671c-2.321,0-4.269-1.748-4.52-4.055l-3.29-30.302  c-0.567-5.222,3.523-9.781,8.776-9.781h50.945c5.252,0,9.343,4.558,8.776,9.781l-3.268,30.098  C286.717,218.854,284.671,220.69,282.232,220.69z" /><path style={{
    fill: "#F5F5F5"
  }} d="M258.045,186.833l16.364,47.079l49.831,1.015c2.051,0.042,2.899,2.648,1.263,3.889l-39.717,30.111  l14.433,47.705c0.595,1.964-1.623,3.575-3.308,2.403L256,290.567l-40.911,28.468c-1.684,1.172-3.902-0.439-3.308-2.403  l14.433-47.705l-39.718-30.111c-1.635-1.239-0.788-3.847,1.263-3.889l49.831-1.015l16.364-47.079  C254.63,184.895,257.37,184.895,258.045,186.833z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };